<template>
  <div>
    <el-row type="flex">
      <iframe :src=getUrl() width="100%" height="800" frameborder="0" scrolling="auto" id="iframename" name="iframename"></iframe>
    </el-row>
  </div>
</template>

<script>
export default {
  data(){
    return {
      currentItem: ['1', '2', '3', '4']
    }
  },
  //事件方法
  methods: {
    getUrl(){
      var iframesrc = "https://elht.nmgrmtzx.top/pams/rongmeiti/tgls/index.html";
      var localLoading = window.location.host;
      if(localLoading.indexOf('.nmgrmtzx.top')>0){
        iframesrc="https://"+localLoading+"/pams/rongmeiti/tgls/index.html";
      }
      console.log("333333"+iframesrc);

      return iframesrc;
    }

  }
}


</script>

<style scoped>
  >>> .el-collapse {
    border: none;
  }

  >>> .el-divider--horizontal {
    margin: 0px;
  }
  >>> .el-tag {
    padding: 0px 30px;
  }
</style>

<style lang="scss" scoped>
  @import '@/assets/style/element-variables.scss';
  .title {
    border: 1px solid #EDEDED;
    border-left-width: 5px;
    border-left-color: $--color-primary;
    margin-bottom: 20px;
  }

  .title p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    margin: 0px;
    padding-left: 20px;
  }

  .title p span {
    font-size: 20px;
    color: $--color-primary;
  }

  .item-list {
    margin: 0px;
  }
  .item-list li {
    margin: 10px 0px;
  }

  .item {
    height: 48px;
    display: flex;
    align-items: center;
  }
</style>
